export const SERVICE_REQUEST_STATUS_COLORS = {
  submitted: "gold",
  reviewing: "blue",
  quote_sent: "magenta",
  quote_approved: "green",
  quote_rejected: "red",
  in_progress: "purple",
  resolved: "cyan",
  closed: "default",
};

export const SERVICE_REQUEST_STATUS_LABELS = {
  submitted: "Submitted",
  reviewing: "Reviewing",
  quote_sent: "Quote Sent",
  quote_approved: "Quote Approved",
  quote_rejected: "Quote Rejected",
  in_progress: "In Progress",
  resolved: "Resolved",
  closed: "Closed",
};

export const SERVICE_REQUEST_PRIORITIES = ["Urgent", "Important", "Low"];

export const SERVICE_REQUEST_STATUS_OPTIONS = [
  { value: "submitted", label: "Submitted" },
  { value: "reviewing", label: "Reviewing" },
  { value: "quote_sent", label: "Quote Sent" },
  { value: "quote_approved", label: "Quote Approved" },
  { value: "quote_rejected", label: "Quote Rejected" },
  { value: "in_progress", label: "In Progress" },
  { value: "resolved", label: "Resolved" },
  { value: "closed", label: "Closed" },
];

export const SERVICE_REQUEST_STEPS = [
  { key: "submitted", label: "Submitted" },
  { key: "reviewing", label: "Reviewing" },
  { key: "quote_sent", label: "Quote Sent", billableOnly: true },
  { key: "quote_approved", label: "Approved", billableOnly: true },
  { key: "in_progress", label: "In Progress" },
  { key: "resolved", label: "Resolved" },
  { key: "closed", label: "Closed" },
];

export const SERVICE_REQUEST_BILLABLE_OPTIONS = [
  { value: "true", label: "Billable" },
  { value: "false", label: "Not Billable" },
];

export const normalizeServiceRequestResponse = (response) => {
  const payload = response?.data || {};
  if (Array.isArray(payload)) {
    return { rows: payload, total: payload.length };
  }
  return {
    rows: payload.results || [],
    total: payload.count || 0,
  };
};
